import {
  AutomationContext,
  AutomationRuleOperator,
  createEnumList,
  customerStateOptions,
  deliveryTypeOptions,
} from '@kinet-open-network/shared/data-access/model';

export type FieldChangeFieldType =
  | 'string'
  | 'number'
  | 'boolean'
  | 'date'
  | 'enum';

export interface IFieldChangeFieldDef {
  key: string;
  label: string;
  type: FieldChangeFieldType;
  options?: { label: string; value: unknown }[];
}

export const fieldChangeContextFields: Partial<
  Record<AutomationContext, IFieldChangeFieldDef[]>
> = {
  customer: [
    { key: 'name', label: 'Meno', type: 'string' },
    { key: 'surname', label: 'Priezvisko', type: 'string' },
    { key: 'phone', label: 'Telefón', type: 'string' },
    { key: 'company', label: 'Firma', type: 'string' },
    { key: 'companyId', label: 'IČO', type: 'string' },
    { key: 'taxpayerId', label: 'DIČ', type: 'string' },
    { key: 'taxId', label: 'IČ DPH', type: 'string' },
    {
      key: 'companyCustomer',
      label: 'Firemný zákazník',
      type: 'boolean',
    },
    { key: 'sipoNumber', label: 'Číslo SIPO', type: 'string' },
    {
      key: 'invoiceDelivery',
      label: 'Spôsob doručenia faktúry',
      type: 'enum',
      options: createEnumList(deliveryTypeOptions),
    },
    {
      key: 'state',
      label: 'Stav zákazníka',
      type: 'enum',
      options: createEnumList(customerStateOptions),
    },
    { key: 'externalId', label: 'Externé ID', type: 'string' },
  ],
};

export const allowedOperatorsByFieldType: Record<
  FieldChangeFieldType,
  AutomationRuleOperator[]
> = {
  string: [
    AutomationRuleOperator.Equals,
    AutomationRuleOperator.NotEquals,
    AutomationRuleOperator.Regexp,
    AutomationRuleOperator.IsSet,
    AutomationRuleOperator.IsNotSet,
  ],
  number: [
    AutomationRuleOperator.Equals,
    AutomationRuleOperator.NotEquals,
    AutomationRuleOperator.GreaterThan,
    AutomationRuleOperator.GreaterThanOrEquals,
    AutomationRuleOperator.LessThan,
    AutomationRuleOperator.LessThanOrEquals,
    AutomationRuleOperator.IsSet,
    AutomationRuleOperator.IsNotSet,
  ],
  boolean: [
    AutomationRuleOperator.Equals,
    AutomationRuleOperator.NotEquals,
    AutomationRuleOperator.IsSet,
    AutomationRuleOperator.IsNotSet,
  ],
  date: [
    AutomationRuleOperator.Equals,
    AutomationRuleOperator.NotEquals,
    AutomationRuleOperator.GreaterThan,
    AutomationRuleOperator.GreaterThanOrEquals,
    AutomationRuleOperator.LessThan,
    AutomationRuleOperator.LessThanOrEquals,
    AutomationRuleOperator.IsSet,
    AutomationRuleOperator.IsNotSet,
  ],
  enum: [
    AutomationRuleOperator.Equals,
    AutomationRuleOperator.NotEquals,
    AutomationRuleOperator.IsSet,
    AutomationRuleOperator.IsNotSet,
  ],
};
